export default {
	'add-journal-cashbox': 'Nakit yövmiye ekleme',
	'adding-journal-cashbox': 'Nakit yövmiye ekle',
	'delete-journal': 'yövmiyeyi sil',
	restriction: 'kayıt',
	'total-received': 'Toplam Alınan',
	'paid-total': 'Toplam Ödenen',
	'new-journal': 'Yeni yövmiye',
	'the-difference': 'Fark',
	'the-journal-has-been-migrated-successfully': 'Yövmiye başarıyla kapatıldı.',
	'journal-saved-successfully': 'Yövmiye başarıyla kaydedildi',
	journal: 'Yövmiye',
	'alert-message-for-date-matching': 'Uyarı: yövmiye tarihi bugünün tarihiyle uyuşmuyor',
	description: 'Açıklama'
}